/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb5_Workflow_0Inputs */

const en_visa_eb5_workflow_0 = /** @type {(inputs: Visa_Eb5_Workflow_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assess the investment structure and supporting source-of-funds documentation.`)
};

const pt_visa_eb5_workflow_0 = /** @type {(inputs: Visa_Eb5_Workflow_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaliar a estrutura de investimento e a documentação de origem de fundos de apoio.`)
};

const es_visa_eb5_workflow_0 = /** @type {(inputs: Visa_Eb5_Workflow_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluar la estructura de inversión y la documentación de origen de fondos de respaldo.`)
};

/**
* | output |
* | --- |
* | "Assess the investment structure and supporting source-of-funds documentation." |
*
* @param {Visa_Eb5_Workflow_0Inputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb5_workflow_0 = /** @type {((inputs?: Visa_Eb5_Workflow_0Inputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb5_Workflow_0Inputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb5_workflow_0(inputs)
	if (locale === "es") return es_visa_eb5_workflow_0(inputs)
	return en_visa_eb5_workflow_0(inputs)
});